import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-papanel',
  templateUrl: './papanel.component.html',
  styleUrls: ['./papanel.component.css']
})
export class PaPanelComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }
 

}
